export default function queryParams(key, options = {}) {
  const params = new URLSearchParams(window.location.search);

  if (options.array) return params.getAll(key) || undefined;
  return params.get(key) || undefined;
}
